export default "__VITE_ASSET__C5Jc8Efv__"